// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GVpw","type":"styles_type__1dgCW","choices":"styles_choices__2GD3E"};